import config from "../config/config.js";
import { getHeaders } from "./utils";

/**
 * Order a credit report through the backend MeridianLink proxy (/credit/pull).
 * The frontend sends the MISMO request XML; the backend adds the authenticated
 * headers and returns the MISMO response as { xml }. Returns the response XML.
 */
export async function pullCredit(requestXml) {
  const headers = getHeaders();
  headers.set("Content-Type", "text/xml");

  // Credit pulls go through the dedicated relay when configured, otherwise the
  // main backend. Normalize a trailing slash so "host" + "credit/pull" is clean.
  const base = (config.creditHost || config.serviceHost || "").replace(
    /\/?$/,
    "/"
  );

  const response = await fetch(base + "credit/pull", {
    method: "POST",
    headers,
    body: requestXml
  });

  let data = {};
  try {
    data = await response.json();
  } catch (e) {
    // fall through to the status check below
  }

  if (!response.ok || data.error) {
    throw new Error(
      data.error || `Credit pull failed (status ${response.status}).`
    );
  }
  return data.xml;
}
